import type { TRuleWithTheme } from '@ackee/fela';

import quotesImg from '../../../../../static/images/quotes.svg';

export const container: TRuleWithTheme = ({ theme: { colors } }) => ({
    position: 'relative',
    padding: '2.75rem 2.75rem',
    color: colors.blue,

    tablet: {
        padding: '5.75rem 5rem',
    },

    '&::before': {
        content: `url(${quotesImg})`,
        position: 'absolute',
        left: 0,

        tablet: {
            left: '2.25rem',
        },
    },

    '& p': {
        margin: 0,
    },
});

export const quote: TRuleWithTheme = () => ({
    margin: '0 0 1.75rem 0',

    fontSize: '1.125rem',
    fontStyle: 'italic',
    lineHeight: '1.875rem',
});

export const author: TRuleWithTheme = () => ({
    textAlign: 'right',
    fontSize: '0.875rem',
    fontStyle: 'normal',

    '&::before': {
        content: '"— "',
    },
});
